import { render, h } from 'preact'
import { App } from './components/App'
import widgetStyles from './styles/widget.css?inline'
import { applyHighlight } from './lib/highlight'
import { recordVisit } from './lib/recentPages'

function init() {
  const urlParams = new URLSearchParams(window.location.search)
  const urlProjectId = urlParams.get('projectId')
  
  const scriptTag =
    (document.currentScript as HTMLScriptElement | null) ??
    document.querySelector<HTMLScriptElement>('script[data-project]')

  const projectId = urlProjectId || scriptTag?.dataset.project
  
  if (!projectId) {
    console.warn('[Spotlight] Missing data-project attribute on script tag.')
    return
  }

  // data-api-url defaults to the script tag's own origin
  const apiBase =
    scriptTag?.dataset.apiUrl ??
    (scriptTag?.src ? new URL(scriptTag.src).origin : '') ??
    ''

  // data-position: 'bottom-center' (default) | 'bottom-right' | 'bottom-left'
  const position = (scriptTag?.dataset.position ?? 'bottom-center') as 'bottom-center' | 'bottom-right' | 'bottom-left' | 'top-center' | 'top-right' | 'top-left'

  // Prevent double-init (e.g. if script is deferred and init fires twice)
  if (document.getElementById('spotlight-widget-host')) return

  // 2. Create host element and append to body
  const host = document.createElement('div')
  host.id = 'spotlight-widget-host'
  // Host itself has no visual styling — the shadow root handles all layout
  const zIndex = scriptTag?.dataset.zIndex ?? '2147483647'
  host.style.cssText = `position:fixed;z-index:${zIndex};inset:0;pointer-events:none;`
  document.body.appendChild(host)

  // 3. Attach shadow root
  const shadow = host.attachShadow({ mode: 'open' })

  // 4. Inject scoped styles
  const styleEl = document.createElement('style')
  styleEl.textContent = widgetStyles
  shadow.appendChild(styleEl)

  // 5. Mount point for Preact
  const mountEl = document.createElement('div')
  mountEl.id = 'spotlight-root'
  mountEl.style.cssText = 'pointer-events:auto;'
  shadow.appendChild(mountEl)

  // 6. Render Preact app
  render(h(App, { projectId, apiBase, position }), mountEl)

  // 7. Apply keyword highlight from previous navigation (if any)
  applyHighlight()

  // 8. Record this page visit for recent pages
  recordVisit(window.location.href)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}
